<template>
  <div>
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card flat class="pa-4 mt-4">
      <br />
      <lazy-observer :onVisible="getAdmissionCount">
        <template v-slot:default>
          <div v-if="loadingMain">
            <v-skeleton-loader type="image" height="900px" />
          </div>
          <div v-else>
            <div v-if="std_div_admission_count.series[0].data.length">
              <chart class="admission-chart" auto-resize :options="std_div_admission_count" />
            </div>
            <div v-else class="text-center pa-4">No data found</div>
          </div>
        </template>
      </lazy-observer>
      <v-divider class="my-5"></v-divider>

      <!-- GENDER RATIO (bar + overall pie + cards) -->
      <lazy-observer :onVisible="getAdmissionGenderRatio">
        <template v-slot:default>
          <div v-if="loadingGender">
            <v-skeleton-loader type="image" />
          </div>
          <div v-else>
            <chart v-if="gender_ratio_chart.series && gender_ratio_chart.series.length" class="chart gender-chart"
              auto-resize :options="gender_ratio_chart" />
            <v-divider class="my-5"></v-divider>

            <v-row align="center" justify="center" class="py-6">
              <v-col cols="12" md="8">
                <chart v-if="overall_gender_chart.series[0].data.length" class="chart" auto-resize
                  :options="overall_gender_chart" />
              </v-col>
              <v-col cols="12" md="2">
                <v-card flat class="py-3 mb-4 gradient-male" rounded="xl">
                  <div class="text-center">
                    <strong class="text-h6">Male #</strong>
                    <div class="text-h3 font-weight-bold">
                      {{ totalMaleCount }}
                    </div>
                  </div>
                </v-card>

                <v-card class="py-3 gradient-female" flat rounded="xl">
                  <div class="text-center">
                    <strong class="text-h6">Female #</strong>
                    <div class="text-h3 font-weight-bold">
                      {{ totalFemaleCount }}
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </template>
      </lazy-observer>

      <v-divider class="my-5"></v-divider>

      <!-- QUOTA RATIO -->
      <lazy-observer :onVisible="getAdmissionQuotaRatio">
        <template v-slot:default>
          <div v-if="loadingQuota">
            <v-skeleton-loader type="image" />
          </div>
          <div v-else>
            <chart v-if="quota_ratio_chart.series && quota_ratio_chart.series.length" class="chart quota-chart"
              auto-resize :options="quota_ratio_chart" />
            <div v-else class="text-center pa-4">No data found</div>
          </div>
        </template>
      </lazy-observer>

      <v-divider class="my-5"></v-divider>

      <!-- RELIGION RATIO -->
      <lazy-observer :onVisible="getAdmissionReligionRatio">
        <template v-slot:default>
          <div v-if="loadingReligion">
            <v-skeleton-loader type="image" />
          </div>
          <div v-else>
            <chart v-if="religion_chart_ratio.series && religion_chart_ratio.series.length" class="chart religion-chart"
              auto-resize :options="religion_chart_ratio" />
            <div v-else class="text-center pa-4">No data found</div>
          </div>
        </template>
      </lazy-observer>

      <v-divider class="my-5"></v-divider>

      <!-- INCOME RATIO -->
      <lazy-observer :onVisible="getAdmissionIncomeRatio">
        <template v-slot:default>
          <div v-if="loadingIncome">
            <v-skeleton-loader type="image" />
          </div>
          <div v-else>
            <chart v-if="income_ratio_chart.series && income_ratio_chart.series.length" class="chart income-chart"
              auto-resize :options="income_ratio_chart" />
            <div v-else class="text-center pa-4">No data found</div>
          </div>
        </template>
      </lazy-observer>

      <v-divider class="my-5"></v-divider>

      <!-- CATEGORY RATIO -->
      <lazy-observer :onVisible="getAdmissionCategoryRatio">
        <template v-slot:default>
          <div v-if="loadingCategory">
            <v-skeleton-loader type="image" />
          </div>
          <div v-else>
            <chart v-if="category_wise_ratio.series && category_wise_ratio.series.length" class="chart category-chart" auto-resize
              :options="category_wise_ratio" />
            <div v-else class="text-center pa-4">No data found</div>
          </div>
        </template>
      </lazy-observer>

    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AdmissionDashboard",
  props: ["selected_ay", "selected_standard", "selected_div"],

  components: {
    // LazyObserver is registered locally below via `components` setter
  },

  data() {
    return {
      snackbar: false,
      totalMaleCount: 0,
      totalFemaleCount: 0,
      color: "",
      snackbar_msg: "",

      // loading flags
      loadingMain: false,
      loadingGender: false,
      loadingQuota: false,
      loadingReligion: false,
      loadingIncome: false,
      loadingCategory: false,

      // caches for API results per filter key
      cache: {
        count: {},
        gender: {},
        quota: {},
        religion: {},
        income: {},
        category: {}
      },

      // Chart option objects (copied from your original)
      income_ratio_chart: {
        title: { text: "Income-Groupwise Admissions", left: "center" },
color: [
    {
      type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
      colorStops: [
        { offset: 0, color: '#e8d7ff' },
        { offset: 1, color: '#c19ee0' }
      ]
    },
    {
      type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
      colorStops: [
        { offset: 0, color: '#ffd7d5' },
        { offset: 1, color: '#dd5a94' }
      ]
    },
    {
      type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
      colorStops: [
        { offset: 0, color: '#dde5b6' },
        { offset: 1, color: '#adc178' }
      ]
    }
  ],
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" }
        },

        legend: {
          bottom: 0
        },

        grid: {
          top: 100,
          left: 120,       
          right: 90,
          bottom: 120,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          name: 'New Admissions',
          nameLocation: 'middle',
          nameGap: 55,
          axisLabel: {
            fontSize: 13,
          }
        },
        yAxis: {
          type: 'category',
          name: 'Class',
          data: [],
          inverse: true,     
          axisLabel: {
            interval: 0,
            fontSize: 12,
            align: 'right',
            margin: 9,
            width: 180,
            overflow: 'breakAll',  
            lineHeight: 18,         
            formatter: function (value) {
              return value.replace(' - ', '\n- ');
            }
          },
          nameLocation: 'middle',
          nameGap: 150
        },

        series: []
      },
      gender_ratio_chart: {
        color: [
          {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [{ offset: 0, color: '#adcfff' }, { offset: 1, color: '#7fdeff' }]
          },
          {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [{ offset: 0, color: '#f9b4ed' }, { offset: 1, color: '#e574bc' }]
          }
        ],

        title: { text: 'Admission Gender Ratio', left: 'center' },

        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },

        legend: { bottom: 0, data: ['Male', 'Female'] },

        grid: {
          top: 100,
          left: 120,        
          right: 90,
          bottom: 120,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          name: 'New Admissions',
          nameLocation: 'middle',
          nameGap: 55,
          axisLabel: {
            fontSize: 13,
          }
        },
        yAxis: {
          type: 'category',
          name: 'Class',
          data: [],
          inverse: true,     
          axisLabel: {
            interval: 0,
            fontSize: 12,
            align: 'right',
            margin: 20,
            width: 180,
            overflow: 'breakAll',   
            lineHeight: 22,         
            formatter: function (value) {
              return value.replace(' - ', '\n- ');
            }
          },
          nameLocation: 'middle',
          nameGap: 130
        },

        series: []
      },

      overall_gender_chart: {
        title: { text: 'Overall Gender Distribution', left: 'center' },
        color: [
          {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [{ offset: 0, color: '#adcfff' }, { offset: 1, color: '#7fdeff' }]
          },
          {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [{ offset: 0, color: '#f9b4ed' }, { offset: 1, color: '#e574bc' }]
          }
        ],
        tooltip: { trigger: 'item', formatter: '{b}: {d}%' },
        legend: { orient: 'horizontal', bottom: 0, data: ['Male', 'Female'] },
        series: [
          {
            name: "Gender",
            type: "pie",
            radius: "70%",
            center: ["40%", "50%"],
            data: [{ value: 0, name: "Male" }, { value: 0, name: "Female" }],
            emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: "rgba(0, 0, 0, 0.5)" } }
          }
        ],
      },
      quota_ratio_chart: {
        title: { text: 'Admissions Quota Ratio', left: 'center' },

        color: [
          {
            type: "linear", x: 0, y: 0, x2: 1, y2: 0,
            colorStops: [{ offset: 0, color: "#f7c3b1" }, { offset: 1, color: "#fe695f" }]
          },
          {
            type: "linear", x: 0, y: 0, x2: 1, y2: 0,
            colorStops: [{ offset: 0, color: "#f9f5dc" }, { offset: 1, color: "#ff9f1c" }]
          }
        ],

        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },

        legend: {
          bottom: 0,
          data: ['General', 'RTE']
        },

        grid: {
          top: 100,
          left: 120,        
          right: 90,
          bottom: 120,
          containLabel: true
        },
        xAxis: {
          type: "value",
          name: "New Admissions",
          nameLocation: "middle",
          nameGap: 60,
          axisLabel: { fontSize: 14,}
        },
        yAxis: {
          type: 'category',
          name: 'Class',
          data: [],
          inverse: true, 
          axisLabel: {
            interval: 0,
            fontSize: 12,
            margin: 12,
            formatter: function (value) {
              return value.length > 15 ? value.substr(0, 12) + '...' : value;
            }
          },
          nameLocation: 'middle',
          nameGap: 100
        },

        series: []
      },
      std_div_admission_count: {
        title: { text: "Number of New Admissions", left: "center" },
        color: [{
          type: "linear",
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: "#cdd993" },
            { offset: 1, color: "#a7c957" }
          ]
        }],

        //tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
        // toolbox: {
        //   show: true,
        //   orient: "horizontal",
        //   itemSize: 16,
        //   itemGap: 10,
        //   right: 20,
        //   top: 10,
        //   feature: {
        //     magicType: { show: true, type: ["line", "bar", "stack"] },
        //     restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        grid: {
          top: 100,
          left: 120,        
          right: 90,
          bottom: 120,
          containLabel: true
        },

        xAxis: {
          type: "value",
          name: "New Admissions",
          nameLocation: "middle",
          nameGap: 60,
          axisLabel: { fontSize: 12,}
        },

        yAxis: {
          type: 'category',
          name: 'Class',
          data: [],
          inverse: true, 
          axisLabel: {
            interval: 0,
            fontSize: 12,
            margin: 12,
            formatter: function (value) {
              return value.length > 15 ? value.substr(0, 12) + '...' : value;
            }
          },
          nameLocation: 'middle',
          nameGap: 100
        },

        series: [{
          name: "New Admissions",
          type: "bar",
          data: [],
          barMaxWidth: 40,          
          barMinHeight: 20,         
          barCategoryGap: '40%',
          label: {
            show: true,
            position: "right",
            fontSize: 12,
          }
        }]
      },
      religion_chart_ratio: {
        title: { text: 'Religion-Wise Admission', left: 'center' },

        color: [
          { type: 'linear', x: 0, y: 0, x2: 1, y2: 0, colorStops: [{ offset: 0, color: '#fdffb6' }, { offset: 1, color: '#ffbe0b' }] },
          { type: 'linear', x: 0, y: 0, x2: 1, y2: 0, colorStops: [{ offset: 0, color: '#ffd6a5' }, { offset: 1, color: '#fb5607' }] },
          { type: 'linear', x: 0, y: 0, x2: 1, y2: 0, colorStops: [{ offset: 0, color: '#ffc6ff' }, { offset: 1, color: '#ff006e' }] },
          { type: 'linear', x: 0, y: 0, x2: 1, y2: 0, colorStops: [{ offset: 0, color: '#bdb2ff' }, { offset: 1, color: '#8338ec' }] },
          { type: 'linear', x: 0, y: 0, x2: 1, y2: 0, colorStops: [{ offset: 0, color: '#a0c4ff' }, { offset: 1, color: '#3a86ff' }] }
        ],

        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },

        legend: {
          bottom: 0
        },

        grid: {
          top: 100,
          left: 150,     
          right: 90,
          bottom: 120,
          containLabel: true
        },

        xAxis: {
          type: 'value',
          name: 'New Admissions',
          nameLocation: 'middle',
          nameGap: 55,
          axisLabel: { fontSize: 13,}
        },

        yAxis: {
          type: 'category',
          name: 'Class',
          data: [],
          inverse: true,
          axisLabel: {
            interval: 0,
            fontSize: 12,
            margin: 18,
            width: 180,
            overflow: 'breakAll',
            lineHeight: 22,
            formatter(value) {
              return value.replace(' - ', '\n- ');
            }
          },
          nameLocation: 'middle',
          nameGap: 150
        },

        series: []
      },
category_wise_ratio: {
  title: { text: 'Category-Wise Admission', left: 'center' },

  color: [
    '#9b5de5', '#f15bb5', '#fee440',
    '#00bbf9', '#00f5d4', '#ff9f1c'
  ],

  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' }
  },

  legend: {
    bottom: 0
  },

  grid: {
    top: 100,
    left: 160,
    right: 80,
    bottom: 120,
    containLabel: true
  },
  xAxis: {
    type: 'value',
    name: 'New Admissions',
    nameLocation: 'middle',
    nameGap: 55,
    axisLabel: { fontSize: 12 }
  },
  yAxis: {
    type: 'category',
    name: 'Class',
    data: [],
    inverse: true,
    axisLabel: {
      interval: 0,
      fontSize: 12,
      width: 180,
      overflow: 'breakAll',
      lineHeight: 20,
      formatter(value) {
        return value.replace(' - ', '\n- ');
      }
    },
    nameLocation: 'middle',
    nameGap: 150
  },

  series: []
}
    };
  },

  computed: {
    filterKey() {
      return `${this.selected_ay || ""}|${this.selected_standard || ""}|${this.selected_div || ""}`;
    }
  },

  watch: {
    selected_ay() { this.onFilterChange(); },
    selected_standard() { this.onFilterChange(); },
    selected_div() { this.onFilterChange(); },
  },

  created() {
    // Register LazyObserver locally as an inline component
    this.$options.components.LazyObserver = {
      name: "LazyObserver",
      props: {
        onVisible: { type: Function, required: true }
      },
      data() {
        return { loaded: false };
      },
      mounted() {
        const observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting && !this.loaded) {
              this.loaded = true;
              try { this.onVisible(); } catch (e) { /* ignore */ }
              observer.disconnect();
            }
          },
          { threshold: 0.15 }
        );
        observer.observe(this.$el);
      },
      render(h) {
        // Render slot content when loaded, otherwise render default skeleton (slot fallback)
        if (this.loaded) return this.$slots.default ? this.$slots.default[0] : h("div");
        // render fallback content (slot named default can contain skeleton)
        return this.$scopedSlots.default
          ? this.$scopedSlots.default()
          : h("div", [h("v-skeleton-loader", { props: { type: "image" } })]);
      }
    };
  },

  methods: {
    showSnackbar(color, msg) {
      this.color = color;
      this.snackbar_msg = msg;
      this.snackbar = true;
    },

    // called when filters change
    onFilterChange() {
      // clear charts and caches so they will reload when user scrolls to them again
      this.clearCharts();
      this.clearCaches();
      // do not call APIs immediately — lazy observer will call when visible
    },

    clearCaches() {
      this.cache = {
        count: {}, gender: {}, quota: {}, religion: {}, income: {}, category: {}
      };
    },

    clearCharts() {
      // reset chart data to initial empty states
      this.std_div_admission_count.xAxis.data = [];
      this.std_div_admission_count.series[0].data = [];

      this.gender_ratio_chart.xAxis.data = [];
      this.gender_ratio_chart.series = [];
      this.overall_gender_chart.series[0].data = [{ value: 0, name: "Male" }, { value: 0, name: "Female" }];

      this.quota_ratio_chart.xAxis.data = [];
      this.quota_ratio_chart.series = [];

      this.religion_chart_ratio.xAxis.data = [];
      this.religion_chart_ratio.series = [];

      this.income_ratio_chart.xAxis.data = [];
      this.income_ratio_chart.series = [];

      this.category_wise_ratio.xAxis.data = [];
      this.category_wise_ratio.series = [];

      this.totalMaleCount = 0;
      this.totalFemaleCount = 0;
    },

    // Utility to get cached key & set cache
    getCache(sectionKey) {
      const key = this.filterKey;
      return this.cache[sectionKey][key];
    },
    setCache(sectionKey, value) {
      const key = this.filterKey;
      this.$set(this.cache[sectionKey], key, value);
    },

    // ------------------ API methods (with caching) ------------------

    async getAdmissionCount() {
      const section = "count";
      const cached = this.getCache(section);
      if (cached) {
        // populate from cache
        this.std_div_admission_count.xAxis.data = cached.xData;
        this.std_div_admission_count.series[0].data = cached.yData;
        return;
      }

      this.loadingMain = true;
      try {
        const res = await axios.post("/AdminDashboard/getAdmissionCount", {
          selected_ay: this.selected_ay,
          selected_standard: this.selected_standard,
          selected_div: this.selected_div,
        });

        if (res.data.flag === "YES" && res.data.data.length > 0) {
          const data = res.data.data;
          const xData = data.map(item => `${item.standard} - ${item.division}`);
          const yData = data.map(item => item.count);

          // this.std_div_admission_count.xAxis.data = xData;
          // this.std_div_admission_count.series[0].data = yData;
          this.std_div_admission_count.yAxis.data = xData;     
          this.std_div_admission_count.series[0].data = yData;
          // cache result
          // this.setCache(section, { xData, yData });
          this.setCache(section, { yData: yData, xData: xData });
        } else {
          this.std_div_admission_count.xAxis.data = [];
          this.std_div_admission_count.series[0].data = [];
          this.showSnackbar("error", "No data found");
        }
      } catch (err) {
        console.error("Error getAdmissionCount:", err);
        this.std_div_admission_count.xAxis.data = [];
        this.std_div_admission_count.series[0].data = [];
        this.showSnackbar("error", "Failed to load data");
      } finally {
        this.loadingMain = false;
      }
    },

    async getAdmissionGenderRatio() {
      const section = "gender";
      const cached = this.getCache(section);
      if (cached) {
        // apply cached data
        this.applyGenderCached(cached);
        return;
      }

      this.loadingGender = true;
      try {
        const res = await axios.post("/AdminDashboard/getAdmissionGenderRatio", {
          selected_ay: this.selected_ay,
          selected_standard: this.selected_standard,
          selected_div: this.selected_div,
        });

        if (res.data.flag === "YES" && res.data.dataForGenderRatio.length > 0) {
          const genderData = res.data.dataForGenderRatio;
          let totalMale = 0;
          let totalFemale = 0;

          // compute totals
          for (const item of genderData) {
            if (item.gender === "Male") totalMale += item.count;
            else if (item.gender === "Female") totalFemale += item.count;
          }

          // overall pie
          const overall = [
            { value: totalMale, name: "Male" },
            { value: totalFemale, name: "Female" }
          ];
          this.overall_gender_chart.series[0].data = overall;
          this.totalMaleCount = totalMale;
          this.totalFemaleCount = totalFemale;

          // build classes list preserving order of appearance
          const classes = [];
          for (const item of genderData) {
            const label = `${item.standard}-${item.division}`;
            if (!classes.includes(label)) classes.push(label);
          }

          // prepare male/female counts per class
          const maleCounts = [];
          const femaleCounts = [];
          for (const cls of classes) {
            const [std, div] = cls.split("-");
            const male = genderData.find(d => d.standard === std && d.division === div && d.gender === "Male");
            const female = genderData.find(d => d.standard === std && d.division === div && d.gender === "Female");
            maleCounts.push(male ? male.count : 0);
            femaleCounts.push(female ? female.count : 0);
          }

          // this.gender_ratio_chart.xAxis.data = classes;
          this.gender_ratio_chart.yAxis.data = classes;

          this.gender_ratio_chart.series = [
            { name: "Male", type: "bar", barGap: 0, data: maleCounts },
            { name: "Female", type: "bar", data: femaleCounts }
          ];

          // cache result
          this.setCache(section, {
            overall,
            totalMale,
            totalFemale,
            classes,
            maleCounts,
            femaleCounts
          });

        } else {
          this.gender_ratio_chart.xAxis.data = [];
          this.gender_ratio_chart.series = [];
        }
      } catch (err) {
        console.error("Error getAdmissionGenderRatio:", err);
        this.gender_ratio_chart.xAxis.data = [];
        this.gender_ratio_chart.series = [];
        this.showSnackbar("error", "Failed to load data");
      } finally {
        this.loadingGender = false;
      }
    },

    applyGenderCached(cached) {
      this.overall_gender_chart.series[0].data = cached.overall || [{ value: 0, name: "Male" }, { value: 0, name: "Female" }];
      this.totalMaleCount = cached.totalMale || 0;
      this.totalFemaleCount = cached.totalFemale || 0;
      // this.gender_ratio_chart.xAxis.data = cached.classes || [];
      this.gender_ratio_chart.yAxis.data = cached.classes || [];

      this.gender_ratio_chart.series = [
        { name: "Male", type: "bar", barGap: 0, data: cached.maleCounts || [] },
        { name: "Female", type: "bar", data: cached.femaleCounts || [] }
      ];
    },

    async getAdmissionQuotaRatio() {
      const section = "quota";
      const cached = this.getCache(section);
      if (cached) {
        // this.quota_ratio_chart.xAxis.data = cached.classes;
        // this.quota_ratio_chart.series = cached.seriesData;
        this.quota_ratio_chart.yAxis.data = cached.classes;
        this.quota_ratio_chart.series = cached.seriesData;

        return;
      }

      this.loadingQuota = true;
      try {
        const res = await axios.post("/AdminDashboard/getAdmissionQuotaRatio", {
          selected_ay: this.selected_ay,
          selected_standard: this.selected_standard,
          selected_div: this.selected_div,
        });

        if (res.data.flag === "YES" && res.data.dataForQuotaRatio.length > 0) {
          const quotaData = res.data.dataForQuotaRatio;
          const totalQuotaCounts = {};
          quotaData.forEach(item => { totalQuotaCounts[item.quota] = (totalQuotaCounts[item.quota] || 0) + item.count; });

          const classes = [...new Set(quotaData.map(item => `${item.standard}-${item.division}`))];
          const quotas = [...new Set(quotaData.map(d => d.quota))];

          const seriesData = quotas.map(quota => {
            const data = classes.map(cls => {
              const [std, div] = cls.split("-");
              const record = quotaData.find(d => d.standard === std && d.division === div && d.quota === quota);
              return record ? record.count : 0;
            });
            return { name: quota, type: "bar", data };
          });

          // this.quota_ratio_chart.xAxis.data = classes;
          // this.quota_ratio_chart.series = seriesData;
          this.quota_ratio_chart.yAxis.data = classes;

          this.quota_ratio_chart.series = seriesData.map(s => ({
  ...s,
  type: 'bar',
  barGap: '20%',                 
  barCategoryGap: '50%',        
  barWidth: '45%',               
  label: {
    show: true,
    position: 'right',
    color: '#333',
    fontSize: 12,
    formatter: (p) => p.value > 0 ? p.value : ''
  },
  emphasis: {
    focus: 'series'
  },
  itemStyle: {
    borderRadius: [0, 4, 4, 0]   
  }
}));

          this.setCache(section, { classes, seriesData, totalQuotaCounts });
        } else {
          this.quota_ratio_chart.xAxis.data = [];
          this.quota_ratio_chart.series = [];
        }
      } catch (err) {
        console.error("Error getAdmissionQuotaRatio:", err);
        this.showSnackbar("error", "Failed to load data");
      } finally {
        this.loadingQuota = false;
      }
    },

    async getAdmissionReligionRatio() {
      const section = "religion";
      const cached = this.getCache(section);
      if (cached) {
        // this.religion_chart_ratio.xAxis.data = cached.classes;
        // this.religion_chart_ratio.series = cached.seriesData;
        this.religion_chart_ratio.yAxis.data = cached.classes;
        this.religion_chart_ratio.series = cached.seriesData;
        return;
      }

      this.loadingReligion = true;
      try {
        const res = await axios.post("/AdminDashboard/getAdmissionReligionRatio", {
          selected_ay: this.selected_ay,
          selected_standard: this.selected_standard,
          selected_div: this.selected_div,
        });

        if (res.data.flag === "YES" && res.data.dataForreligionRatio.length > 0) {
          const religionData = res.data.dataForreligionRatio;

          const classes = [...new Set(religionData.map(item => `${item.standard}-${item.division}`))];
          const religions = [...new Set(religionData.map(item => item.religion))];

          const seriesData = religions.map(religion => {
            const data = classes.map(cls => {
              const [std, div] = cls.split("-");
              const record = religionData.find(d => d.standard === std && d.division === div && d.religion === religion);
              return record ? record.count : 0;
            });
            return { name: religion, type: "bar", data };
          });

          // this.religion_chart_ratio.xAxis.data = classes;
          // this.religion_chart_ratio.series = seriesData;
          this.religion_chart_ratio.yAxis.data = classes;
          this.religion_chart_ratio.series = seriesData.map(s => ({
            ...s,
            type: 'bar',

            barWidth: 6,
            barGap: '0%',
            barCategoryGap: '35%',

            label: {
              show: true,
              position: 'right',
              color: '#000',
              formatter: (p) => {
                return p.value > 0 ? p.value : '';   
              }
            },

  // ⭐ THIS REMOVES ZERO BARS COMPLETELY
  itemStyle: {
    opacity: (params) => {
      return params.value > 0 ? 1 : 0;
    }
  }
}));

          this.setCache(section, { classes, seriesData });
        } else {
          this.religion_chart_ratio.xAxis.data = [];
          this.religion_chart_ratio.series = [];
        }
      } catch (err) {
        console.error("Error getAdmissionReligionRatio:", err);
        this.showSnackbar("error", "Failed to load data");
      } finally {
        this.loadingReligion = false;
      }
    },

    async getAdmissionIncomeRatio() {
      const section = "income";
      const cached = this.getCache(section);
      if (cached) {
        // this.income_ratio_chart.xAxis.data = cached.classes;
        // this.income_ratio_chart.series = cached.seriesData;
        this.income_ratio_chart.yAxis.data = cached.classes;
        this.income_ratio_chart.series = cached.seriesData;

        return;
      }

      this.loadingIncome = true;
      try {
        const res = await axios.post("/AdminDashboard/getAdmissionIncomeRatio", {
          selected_ay: this.selected_ay,
          selected_standard: this.selected_standard,
          selected_div: this.selected_div,
        });

        if (res.data.flag === "YES" && res.data.dataForIncomeRatio.length > 0) {
          const incomeData = res.data.dataForIncomeRatio;

          const classes = [...new Set(incomeData.map(item => `${item.standard}-${item.division}`))];
          const incomeGroups = [...new Set(incomeData.map(item => item.income_group))];

          const seriesData = incomeGroups.map(group => {
            const data = classes.map(cls => {
              const [std, div] = cls.split("-");
              const record = incomeData.find(d => d.standard === std && d.division === div && d.income_group === group);
              return record ? record.count : 0;
            });
            return { name: group, type: "bar", barGap: 0, label: { show: true, position: "top" }, data };
          });

          // this.income_ratio_chart.xAxis.data = classes;
          // this.income_ratio_chart.series = seriesData;
          this.income_ratio_chart.yAxis.data = classes;

          this.income_ratio_chart.series = seriesData.map(s => ({
            ...s,
            type: 'bar',
            barGap: '15%',
            barCategoryGap: '10%',
            barWidth: '40%',
            label: {
              show: true,
              position: 'right',
              color: '#333',
              fontSize: 12,
              formatter: (p) => p.value > 0 ? p.value : ''   // Hide zero labels
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              borderRadius: [0, 6, 6, 0]     
            }
          }));

          this.setCache(section, { classes, seriesData });
        } else {
          this.income_ratio_chart.xAxis.data = [];
          this.income_ratio_chart.series = [];
        }
      } catch (err) {
        console.error("Error getAdmissionIncomeRatio:", err);
        this.showSnackbar("error", "Failed to load data");
      } finally {
        this.loadingIncome = false;
      }
    },

    async getAdmissionCategoryRatio() {
      const section = "category";
      const cached = this.getCache(section);
      if (cached) {
        // this.category_wise_ratio.xAxis.data = cached.classes;
        // this.category_wise_ratio.series = cached.seriesData;
        this.category_wise_ratio.yAxis.data = cached.classes;
        this.category_wise_ratio.series = cached.seriesData;

        return;
      }

      this.loadingCategory = true;
      try {
        const res = await axios.post("/AdminDashboard/getAdmissionCategoryRatio", {
          selected_ay: this.selected_ay,
          selected_standard: this.selected_standard,
          selected_div: this.selected_div,
        });

        if (res.data.flag === "YES" && res.data.datacategoryRatio.length > 0) {
          const categoryData = res.data.datacategoryRatio;

          const classes = [...new Set(categoryData.map(item => `${item.standard}-${item.division}`))];
          const categories = [...new Set(categoryData.map(item => item.category))];

          const seriesData = categories.map(category => {
            const data = classes.map(cls => {
              const [std, div] = cls.split("-");
              const record = categoryData.find(d => d.standard === std && d.division === div && d.category === category);
              return record ? record.count : 0;
            });
            return { name: category, type: "bar", label: { show: true, position: "top" }, emphasis: { focus: "series" }, data };
          });

          // this.category_wise_ratio.xAxis.data = classes;
          // this.category_wise_ratio.series = seriesData;
          this.category_wise_ratio.yAxis.data = classes;

          this.category_wise_ratio.series = seriesData.map(s => ({
            ...s,
            type: 'bar',
            barGap: 0,
            label: {
              show: true,
              position: 'right',
              color: '#000',
              formatter: p => p.value > 0 ? p.value : ''
            }
          }));

          this.setCache(section, { classes, seriesData });
        } else {
          this.category_wise_ratio.xAxis.data = [];
          this.category_wise_ratio.series = [];
        }
      } catch (err) {
        console.error("Error getAdmissionCategoryRatio:", err);
        this.showSnackbar("error", "Failed to load data");
      } finally {
        this.loadingCategory = false;
      }
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  height: 400px;
  max-width: 750px;
  margin: 0 auto;
}

.gradient-male {
  background: #adcfff;
}

.gradient-female {
  background: #f9b4ed;
}

.text-center {
  text-align: center;
}

.chart {
  height: 400px;
  width: 100%;
  min-width: 800px;
  /* Forces the chart to be wide enough for many bars */
  /* Remove max-width: none; if you had it */
}

.chart-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid #eee;
  border-radius: 8px;
  margin: 20px 0;
  padding: 8px 0;
  background: #fafafa;
}

.chart-container {
  height: 400px;
  width: max-content;
  /* Allows chart to grow beyond viewport */
}

.simple-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  /* Simple native horizontal scrollbar */
  overflow-y: hidden;
  padding-bottom: 15px;
  /* Space for the scrollbar */
  margin: 20px 0;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
}

.admission-chart {
  height: 1000px !important;
  /* Critical: gives room for ~25–30 classes cleanly */
  width: 100%;
}

.gender-chart {
  height: 950px !important;
}

.quota-chart {
  height: 950px !important;
}

.religion-chart {
  height: 1000px !important;
}

.income-chart {
  height: 1000px !important;
}
.category-chart {
  height: 1000px !important;
}
/* Optional: Make the native scrollbar look nicer */
.simple-scroll-wrapper::-webkit-scrollbar {
  height: 12px;
}

.simple-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.simple-scroll-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 10px;
}

.simple-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}
</style>
